import arrowDownIcon from '~/assets/icons/arrow_down.svg';
import arrowLeftIcon from '~/assets/icons/arrow_left.svg';
import arrowRightIcon from '~/assets/icons/arrow_right.svg';
import arrowUpIcon from '~/assets/icons/arrow_up.svg';
import mouseLeftIcon from '~/assets/icons/mouse_left.svg';
import mouseMiddleIcon from '~/assets/icons/mouse_middle.svg';
import mouseRightIcon from '~/assets/icons/mouse_right.svg';
import spaceIcon from '~/assets/icons/space.svg';
import {
	StyledButton,
	StyledKeyIcon,
	StyledKeyLabel,
} from './KeyButton.styled';

interface IControlKeyProps {
	name: string;
}

const controlIcons: { [key: string]: string } = {
	ArrowLeft: arrowLeftIcon,
	ArrowUp: arrowUpIcon,
	ArrowRight: arrowRightIcon,
	ArrowDown: arrowDownIcon,
	MouseRight: mouseRightIcon,
	MouseMiddle: mouseMiddleIcon,
	MouseLeft: mouseLeftIcon,
	Space: spaceIcon,
};

const Key = ({ name }: IControlKeyProps) => {
	const iconPath = controlIcons[name];
	if (iconPath !== undefined) {
		return (
			<StyledKeyIcon
				$src={iconPath}
				style={name === 'Space' ? { maskSize: '20px 12px' } : undefined}
			/>
		);
	}
	return <StyledKeyLabel>{name}</StyledKeyLabel>;
};

const KeyButton = ({ keyName }: { keyName: string }) => {
	return (
		<StyledButton $width={keyName === 'Space' ? 30 : 20}>
			<Key name={keyName} />
		</StyledButton>
	);
};

export { KeyButton };
